import { Box, BoxProps, styled } from '@mui/material';
import useIsSessionLivePage from '../Hooks/useIsSessionLivePage';
import useSessionContext from '../LiveContext/SessionContextProvider/useSessionContext';

const InnerPageContentLayout = styled((props: BoxProps & { fullWidth: boolean }) => {
  const { fullWidth, ...rest } = props;
  return <Box {...rest} />;
})(({ fullWidth }) => ({
  flexGrow: 1,
  margin: fullWidth ? '8px 12px' : '8px 0px 8px 12px',
  padding: '8px 12px',
  borderRadius: 6,
  backgroundColor: 'white',
  flexDirection: 'column',
  display: 'flex',
  overflow: 'auto',

  '&::-webkit-scrollbar-track': {
    backgroundColor: 'white',
    borderRadius: 6,
  },
}));

export default function PageContentLayout(props: BoxProps & { inDialog?: boolean }) {
  const { session } = useSessionContext();
  const sessionHome = useIsSessionLivePage();

  return <InnerPageContentLayout {...props} fullWidth={!session || sessionHome} />;
}
